import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { Container as AdSlot } from "~/components/advertisement/ad-slots/ad-slot/styles";
import { BaseLink } from "~/components/common/base-link";

import Background from "./background.svg?url";
import OlympicLogo from "./olympic-logo.svg";

export const Container = styled.div`
  display: grid;
  grid: "logo ads" min-content/ 1fr 100px;

  padding-block: 24px 16px;
  padding-inline: 20px;

  background-image: url(${Background});
  background-repeat: no-repeat;
  background-size: cover;
  ${props => props.theme.breakpoints.up("homeDesktop")} {
    background-size: 300px 91px;
  }
`;

export const LogoLink = styled(BaseLink)`
  grid-area: logo;
`;

export const StyledOlympicLogo = styled(OlympicLogo)``;

export const Paris = styled.div`
  color: #001246;
  font-weight: 400;
  font-size: 32px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: 38.4px;
  text-transform: uppercase;
`;

export const AdContainer = styled.div`
  grid-area: ads;

  display: flex;
  align-items: flex-end;
  ${AdSlot} {
    justify-content: flex-start;
    align-items: flex-start;
  }
`;
